// Local
import Animate from './partials/animate';
import Form from './partials/form';
import ModalMenu from "./partials/modal-menu";
import AppMenu from "./partials/app-menu";
import AlertClose from "./partials/alert-close";
import UploadControl from "./partials/upload-control";
import SessionTimer from "./partials/session-timer";


window.initDom = ($wrapper) => {
    console.debug($wrapper, 'init');
    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-form]').forEach($el => (new Form($el)));
    $wrapper.querySelectorAll('[data-modal-menu]').forEach($el => (new ModalMenu($el)));
    $wrapper.querySelectorAll('[data-app-chat]').forEach($el => (new AppMenu($el)));
    $wrapper.querySelectorAll('[data-alert]').forEach($el => (new AlertClose($el)));
    $wrapper.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));
    $wrapper.querySelectorAll('[data-session-timer]').forEach($el => new SessionTimer($el));
}

(function() {
    window.initDom(document);
})();